// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__20Fts","label":"Radio_label__5DbJl","checkMark":"Radio_checkMark__2WlBu","disabled":"Radio_disabled__1LAxI"};